import { createSelector } from "@reduxjs/toolkit";
import { RootState } from "@store/index";
import { ImpersonationState } from "@impersonateUser/models";

export const userSliceSelector = (state: RootState) => state.user;

export const loggedInUserPreferencesSelector = (state: RootState) => state.user.data!.preferences;

export const loggedInSelectedIAGroupIdSelector = (state: RootState) => state.user.data!.selectedAccountGroup;

export const userSegmentFunctionSelector = (state: RootState) => state.user.data?.segmentFunction;

/*Local impersonation state selector*/
const impersonationStateSelector = (state: RootState): ImpersonationState =>
  (state as any).impersonation ??
  ({ canImpersonate: false, isImpersonating: false, errorImpersonating: false, user: null } as ImpersonationState);

export const effectiveUserSelector = createSelector(
  userSliceSelector,
  impersonationStateSelector,
  (userSlice, impersonationState) => {
    if (impersonationState.isImpersonating && impersonationState.user) {
      // Return impersonated user data in the same structure as userSlice
      return {
        loading: false,
        error: null,
        data: {
          id: impersonationState.user.id,
          sfdcContactId: impersonationState.user.sfdcContactId || "",
          email: impersonationState.user.email,
          name: impersonationState.user.name,
          external: false, // Not available in impersonated data, use default
          userType: "", // Not available in impersonated data, use default
          selectedAccountGroup: impersonationState.user.selectedAccountGroup,
          preferences: impersonationState.user.preferences,
          permissions: userSlice.data?.permissions || [], // Use admin's permissions for authorization
          segmentFunction: impersonationState.user.segmentFunction,
        },
      };
    }

    return userSlice;
  }
);
